
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/pager/pager.component.js'
      import type { DdsPaginationChangeEvent } from '../../events/events'
      export type { DdsPaginationChangeEvent } from '../../events/events'

      const tagName = 'dap-ds-pager'

      /**
 * `dap-ds-pager`
 * @summary A pager is a component that displays pagination controls.
 * @element dap-ds-pager
 * @title - Pager
 *
 * @event {{ action: string, pagination: { pageIndex: number, pageSize: number } }} dds-pagination-change - Event fired when the pagination changes
 *
 * @csspart base - The main pager container.
 * @csspart first - The first page button.
 * @csspart previous - The previous page button.
 * @csspart next - The next page button.
 * @csspart last - The last page button.
 *
 * @cssproperty --dds-pager-spacing-vertical - The vertical spacing of the pager.
 * @cssproperty --dds-pager-spacing-horizontal - The horizontal spacing of the pager.
 * @cssproperty --dds-pager-button-padding - The padding of the pager buttons.
 * @cssproperty --dds-pager-button-border-width - The border width of the pager buttons.
 * @cssproperty --dds-pager-button-border-color - The border color of the pager buttons.
 * @cssproperty --dds-pager-button-border-radius - The border radius of the pager buttons.
 * @cssproperty --dds-pager-button-background - The background color of the pager buttons.
 * @cssproperty --dds-pager-button-font-size - The font size of the pager buttons.
 * @cssproperty --dds-pager-button-font-weight - The font weight of the pager buttons.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsPaginationChange: 'dds-pagination-change' as EventName<DdsPaginationChangeEvent>
        },
        displayName: "DapDSPager"
      })

      export default reactWrapper
    